export default "__VITE_ASSET__By7szLOb__"